<template>
    <select
        v-model="selected"
        :class="selectClass"
        @input="setValue($event)"
        :disabled="disabled"
        :key="selected + 'x'"
    >
        <option value="" v-if="unselectedLabel">{{ $t(unselectedLabel) }}</option>
        <option
            v-for="(item, index) in items"
            :value="getValue(item)"
            :key="index + 0"
            :class="{'font-italic': disabled}"
        >
            {{ getLabel(item, index) }}
        </option>
    </select>
</template>

<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array,
      required: true
    },
    valueAttribute: {
      default: 'id',
      type: String,
      required: false
    },
    labelAttribute: {
      default: 'name',
      type: String,
      required: false
    },
    selection: {
      default: null,
      type: String | Number,
      required: false
    },
    selectClass: {
      default: 'right-chevron',
      type: String,
      required: false
    },
    noneLabel: {
      default: '',
      type: String,
      required: false
    },
    disabled: {
      type: String | Boolean,
      required: false
    },
    forceFirstOption: {
      type: Boolean,
      required: false
    },
    customLabel: {
      type: String,
      required: false
    },
    simpleValue: {
      default: true,
      type: Boolean,
      required: false
    },
    translateLabels: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      selected: null,
      unselectedLabel: this.noneLabel
    }
  },
  computed: {
    label () {
      let needle = this.selected
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i][this.valueAttribute] === needle) {
          return this.items[i][this.labelAttribute]
        }
      }
      return ''
    }
  },
  methods: {
    setValue (event) {
      this.selected = event.target.value
      if (!this.simpleValue) {
        this.$emit('update:selection', this.items[event.target.selectedIndex])
      } else {
        this.$emit('update:selection', event.target.value)
      }
    },
    getValue (item) {
      if (!isNaN(item)) {
        return item
      }
      return (typeof item[this.valueAttribute] !== 'undefined') ? item[this.valueAttribute] : item.id
    },
    getLabel (item, index) {
      if (!isNaN(item)) {
        return item
      }
      if (this.customLabel) {
        item.name_NL = this.customLabel + ' ' + (index + 1)
      }
      if (typeof item[this.labelAttribute] !== 'undefined') {
        return this.translateLabels ? this.$t(item[this.labelAttribute]) : item[this.labelAttribute]
      }
      return item.name_NL
    }
  },
  mounted () {
    if (this.forceFirstOption && this.selection === null) {
      this.selected = ''
      return
    }
    // nothing selected
    if ((this.selection === '0' || this.selection === 0) && this.items.length) {
      this.selected = this.items[0]
      if (this.selection.hasOwnProperty('id')) {
        this.selected = this.selection.id
      } else {
        this.selected = this.selection
      }
      this.$emit('update:selection', this.selected)
    // a number
    } else if (!isNaN(this.selection)) {
      this.selected = parseInt(this.selection)
      this.$emit('update:selection', this.selected)
    } else if (this.selection) {
      if (this.selection.hasOwnProperty('id')) {
        this.selected = this.selection.id
      } else {
        this.selected = this.selection
      }
      this.$emit('update:selection', this.selected)
    } else if (this.items.length && !this.selection) {
      this.selected = this.items[0][this.valueAttribute]
      this.$emit('update:selection', this.selected)
    } else {
      this.selected = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/BasicDropDown.vue